import { Link } from 'react-router-dom';

const categoryLinks = [
  { label: 'AI 스킬', to: '/products' },
  { label: '자동화 매크로', to: '/products' },
  { label: 'AI 워크플로우', to: '/products' },
  { label: '노션 템플릿', to: '/products' },
  { label: '크롬 확장 프로그램', to: '/products' },
  { label: '인디 게임', to: '/products' },
];

const helpLinks = [
  { label: '이용 방법', to: '/#how' },
  { label: '판매자 되기', to: '/#sell' },
  { label: '고객센터', to: '/products' },
  { label: '자주 묻는 질문', to: '/products' },
];

const companyLinks = [
  { label: 'HANDLED 소개', to: '/#how' },
  { label: '이용약관', to: '/terms' },
  { label: '개인정보처리방침', to: '/privacy' },
  { label: '판매자 정책', to: '/#sell' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300 text-foreground-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500 text-foreground-950 font-bold text-lg">
                H
              </span>
              <span className="font-display text-xl font-semibold tracking-tight text-white">
                HANDLED
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              AI 스킬부터 인디 게임까지, 검증된 디지털 상품을 안전하게 거래하는
              마켓플레이스입니다.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['twitter-x', 'instagram', 'youtube', 'github'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-300 text-foreground-300 hover:bg-primary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                  aria-label={icon}
                >
                  <i className={`ri-${icon}-line text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">카테고리</h4>
            <ul className="space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">이용 안내</h4>
            <ul className="space-y-3">
              {helpLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.to} className="text-sm text-foreground-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">회사</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.to} className="text-sm text-foreground-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} HANDLED. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-foreground-500">
            <Link to="/terms" className="hover:text-white transition-colors">이용약관</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">개인정보처리방침</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}